export default '/build/11366882.svg'